import { render, staticRenderFns } from "./DiariesAggregator.vue?vue&type=template&id=5951c70e&scoped=true"
import script from "./DiariesAggregator.vue?vue&type=script&lang=js"
export * from "./DiariesAggregator.vue?vue&type=script&lang=js"
import style0 from "./DiariesAggregator.vue?vue&type=style&index=0&id=5951c70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5951c70e",
  null
  
)

export default component.exports